import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import NutshellPowerAi from './icon-nutshell-powerai.svg';

function SvgComponent() {
    return <NutshellPowerAi width={100} height={32} />;
}
SvgComponent.iconName = 'nutshellPowerAi';

export const NutshellPowerAiIcon = svgIconWrapper(SvgComponent);
